export const defaultRankTransformer = {
  RANK_TWO: '2',
  RANK_THREE: '3',
  RANK_FOUR: '4',
  RANK_FIVE: '5',
  RANK_SIX: '6',
  RANK_SEVEN: '7',
  RANK_EIGHT: '8',
  RANK_NINE: '9',
  RANK_TEN: 'T',
  RANK_JACK: 'J',
  RANK_QUEEN: 'Q',
  RANK_KING: 'K',
  RANK_ACE: 'A',
};

export const defaultSuitTransformer = {
  SUIT_CLUB: 'c',
  SUIT_DIAMOND: 'd',
  SUIT_HEART: 'h',
  SUIT_SPADE: 's',
};

export const gameIdToServiceTransformer = {
  omaha: 'Omaha Hi',
  texas: 'Texas Holdem',
};

export const gameIdToApiTransformer = {
  texas: 'holdem',
  texasHL: 'holdem8',
  omaha: 'omaha',
  omahaHL: 'omaha8',
  stud: '7stud',
  studHL: '7stud8',
  studHLNQ: '7stud8nq',
  razz: 'razz',
};